import React from 'react';
import { getTrans, replaceParams } from '@/utils/tools';
import { Copywriting } from '@/utils/constants';
import './index.scss';

export default class SessionTransfer extends React.Component<{
  agentName: string;
}> {
  render() {
    const { agentName } = this.props;
    return (
      <div className="session-transfer">
        {replaceParams(getTrans(Copywriting.TRANSFER_NEW_AGENT_INCOMING), { agent_name: agentName })}
      </div>
    );
  }
}
